import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { UserService } from '../user.service';

export const userRoleAdminGuard = () => {
  const userService = inject(UserService);

  return userService.user$.pipe(
    take(1),
    map((user) => {
      console.log('user', user);
      const isUser = user?.isAdmin;
      if (!isUser) {
        if (user) {
          userService.redirectUser(user);
        }
      }

      return isUser;
    })
  );
};
